module.exports = __webpack_public_path__ + "img/FAQ-A.447eba87.jpg";